import { styleScreenHeader } from "./style";
import { AiOutlineLogin, AiOutlineMenu } from "react-icons/ai";
import { BiHelpCircle } from "react-icons/bi";
import { colors } from "../../styles/style";

import { signOut } from "../../services/common/auth";
import useAuth from "../../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";

const Header = ({ onSelectOption }) => {
  const { setCurrentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  async function handleSignOut() {
    await signOut();
    setCurrentUser(null);
    const origin = location.state?.from?.pathname || "/login";
    navigate(origin);
  }

  return (
    <div style={styleScreenHeader.headerContainer}>
      <div className="row">
        <div className="col-9" />
        <div className="col-2 row">
          <div className={"col"}>
            <button
              type="button"
              onClick={() => handleSignOut()}
              style={styleScreenHeader.buttonLogout}
            >
              <AiOutlineLogin size={26} color={colors.GRAY_4_COLOR} />
            </button>
          </div>

          <div className={"col"}>
            <button
              type="button"
              onClick={() => onSelectOption("help")}
              style={styleScreenHeader.buttonLogout}
            >
              <BiHelpCircle size={26} color={colors.GRAY_4_COLOR} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
